// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  :root {
    --v-focus-color: var(--gc-color-primary-rgb);
    --v-focus-box-shadow: 0 0 0 0.2rem rgba(var(--v-focus-color), 0.5);
    --v-border-radius: 4px;
  }
  :root .v-component-container .p-button:not(.p-inputnumber-button), :root .v-component-container .p-multiselect {
    min-height: 48px;
  }
  :root .v-component-container .p-inputtext, :root .v-component-container .p-dropdown {
    background: var(--v-input-background-color);
  }
  :root .v-component[hidden] {
    display: none;
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/style.sass"],"names":[],"mappings":"AAAA;EACI;IACI,4CAAA;IACA,kEAAA;IACA,sBAAA;EACN;EAMU;IACI,gBAAA;EAJd;EAKU;IACI,2CAAA;EAHd;EAMU;IACI,aAAA;IACA,yBAAA;YAAA,iBAAA;IACA,oBAAA;EAJd;AACF","sourcesContent":["@layer vierkant\n    :root\n        --v-focus-color: var(--gc-color-primary-rgb)\n        --v-focus-box-shadow: 0 0 0 0.2rem rgba(var(--v-focus-color), 0.5)\n        --v-border-radius: 4px\n\n        .v-component-container\n            // .p-element\n                // transition-property: background-color, color, border-radius, outline, border\n                // transition-duration: 0.25s\n                // transition-timing-function: ease-out\n            .p-button:not(.p-inputnumber-button), .p-multiselect\n                min-height: 48px\n            .p-inputtext, .p-dropdown\n                background: var(--v-input-background-color)\n\n        .v-component\n            &[hidden]\n                display: none\n                user-select: none\n                pointer-events: none"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
